import { enumEducationalVideoItemType } from '..';
import { MdbError } from '../../../errorObjects/MdbError';
import { enumMdbErrorType } from '../../../errorObjects/enums';

/**
 * @class enumEducationalVideoItemTypeConvert Provides to/from string conversions for enumEducationalVideoItemType values.
 */
export class enumEducationalVideoItemTypeConvert {
  public static toString(subscriptionTypeEnum: enumEducationalVideoItemType): string {
    return subscriptionTypeEnum.toString();
  }

  public static fromString(productVideoItemType: string): enumEducationalVideoItemType {
    let productVideoItemTypeEnum: enumEducationalVideoItemType = enumEducationalVideoItemType.Catalog;

    switch (productVideoItemType) {
      case enumEducationalVideoItemTypeConvert.toString(enumEducationalVideoItemType.Catalog):
        productVideoItemTypeEnum = enumEducationalVideoItemType.Catalog;
        break;

      case enumEducationalVideoItemTypeConvert.toString(enumEducationalVideoItemType.InformationalVideo):
        productVideoItemTypeEnum = enumEducationalVideoItemType.InformationalVideo;
        break;

      case enumEducationalVideoItemTypeConvert.toString(enumEducationalVideoItemType.TrainingVideo):
        productVideoItemTypeEnum = enumEducationalVideoItemType.TrainingVideo;
        break;

      default:
        throw new MdbError(`enumEducationalVideoItemTypeConvert.fromString. Unrecognized/unsupported enumEducationalVideoItemType string: ${productVideoItemType}`, enumMdbErrorType.InvalidOperation);
    }

    return productVideoItemTypeEnum;
  }
}